var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left",attrs:{"id":"memberPurposeList"}},[_vm._v("                  \n    "+_vm._s(this.purposeList)+"                   \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }